import React from 'react';
import classNames from 'classnames';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { Container } from '@fiverr-private/layout_components';
import { PriceWithFees, usePricingData, BUYABLE_TYPE } from '@fiverr-private/price_upfront_components';
import { SELLER_COUPON_TYPES } from '../../../GigPage/constants';
import { useShowPromotionDiscountedPriceBIEvent } from '../hooks/useShowPromotionDiscountedPriceBIEvent';
import { getPriceDisplayTranslationKey } from '../../../../utils/priceUpfront';
import { HeaderProps } from '../HeaderDefault/types';
import PriceTooltipIcon from '../PriceTooltipIcon';
import SubscriptionDrawerLabel from './SubscriptionDrawerLabel';
import SubscriptionPackageDescription from './SubscriptionPackageDescription';
import './style.scss';

const HeaderRecurring: React.FC<HeaderProps> = ({
  title,
  showPrice,
  description,
  showPriceTooltip,
  discountedPriceSection,
  currentPrice,
  currentPriceWithPromotionDiscount,
  currency,
  isRtoGig,
}) => {
  const { coupon, priceDisplayStatus = 'none' } = useGigPageContext();

  useShowPromotionDiscountedPriceBIEvent(!!discountedPriceSection);

  {
    /* When the promotion is present, the SubscriptionDrawerLabel component
        is moved under the "Continue" CTA. */
  }
  const isSubscriptionLabelHidden = isRtoGig || (coupon && coupon.type === SELLER_COUPON_TYPES.PROMOTION);

  const { isPriceUpfrontEnabled } = usePricingData();
  const netPrice = currentPriceWithPromotionDiscount ?? currentPrice;

  return (
    <header className="header-recurring">
      <h3>
        {showPrice && (
          <div className="price-wrapper">
            <span className={classNames({ 'price-with-tooltip': !!showPriceTooltip })}>
              <Container>
                <PriceWithFees
                  netPrice={netPrice}
                  currency={currency}
                  buyableType={BUYABLE_TYPE.GIG}
                  typographyProps={{ size: priceDisplayStatus === 'both' ? 'b_md' : 'b_xl' }}
                />
                {priceDisplayStatus !== 'none' && (
                  <Text
                    paddingLeft="1.5"
                    size={priceDisplayStatus === 'both' ? 'b_md' : 'b_xxl'}
                    style={{ display: 'inline-block' }}
                    color="bodySecondary"
                    as="span"
                  >
                    <I18n k={getPriceDisplayTranslationKey(priceDisplayStatus)} />
                  </Text>
                )}
              </Container>
              {showPriceTooltip && !isPriceUpfrontEnabled && <PriceTooltipIcon />}
            </span>
            {!isSubscriptionLabelHidden && <SubscriptionDrawerLabel />}
          </div>
        )}
      </h3>
      {discountedPriceSection && <div className="m-t-4">{discountedPriceSection}</div>}
      <SubscriptionPackageDescription title={title} description={description} />
    </header>
  );
};

export default HeaderRecurring;
